import ProgressAmount from '../../../../components/ProgressAmount/ProgressAmount';
import './perCategory.css';

const PerCategory = ({ DesignSystemComponents, title, data }) => {
  const { Card } = DesignSystemComponents;

  return (
    <Card specialPadding='py-4 px-0' className='per-category'>
      <h4 className='fw-semibold mb-3 px-4'>{title}</h4>
      <div className='per-category-content px-4'>
        {data.map((item, index) => (
          <ProgressAmount
            key={index}
            title={item.name}
            amount={item.amount}
            percentage={item.percentage}
            className='mb-3'
          />
        ))}
      </div>
    </Card>
  );
};

export default PerCategory;
